import { createReducer } from 'typesafe-actions';
import { CompareLists } from '../types';
import { combineReducers } from 'redux';
import { PRODUCTS_COMPARE_LISTS } from './actions';

const compareLists = createReducer<CompareLists | null>(null)
  .handleAction(PRODUCTS_COMPARE_LISTS.cancel, () => null)
  .handleAction(PRODUCTS_COMPARE_LISTS.success, (_, { payload }) => payload)
  .handleAction(PRODUCTS_COMPARE_LISTS.failure, (state) => state);

const compareListsError = createReducer<Response | Error | null>(null)
  .handleAction(PRODUCTS_COMPARE_LISTS.failure, (_, { payload }) => payload)
  .handleAction(
    [PRODUCTS_COMPARE_LISTS.request, PRODUCTS_COMPARE_LISTS.success, PRODUCTS_COMPARE_LISTS.cancel],
    () => null,
  );

const compareListsLoading = createReducer(false)
  .handleAction(PRODUCTS_COMPARE_LISTS.request, () => true)
  .handleAction(
    [PRODUCTS_COMPARE_LISTS.success, PRODUCTS_COMPARE_LISTS.failure, PRODUCTS_COMPARE_LISTS.cancel],
    () => false,
  );

export const productsCompareListsReducer = combineReducers({
  data: compareLists,
  isLoading: compareListsLoading,
  error: compareListsError,
});
